import { render, staticRenderFns } from "./runDoc.vue?vue&type=template&id=36a3f371"
import script from "./runDoc.vue?vue&type=script&lang=js"
export * from "./runDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a3f371')) {
      api.createRecord('36a3f371', component.options)
    } else {
      api.reload('36a3f371', component.options)
    }
    module.hot.accept("./runDoc.vue?vue&type=template&id=36a3f371", function () {
      api.rerender('36a3f371', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/pca/run/runDoc.vue"
export default component.exports